import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ThirdPartyForm_Emitters_Update_Mutation = graphql(`
  mutation ThirdPartyForm_Emitters_Update(
    $emitterIds: [Id!]!
    $thirdPartyId: Id!
    $versionData: VersionDataInput
  ) {
    updateEmitters(
      emitterIds: $emitterIds
      thirdPartyId: $thirdPartyId
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export const useUpdateEmittersMutation = () =>
  useGraphQLMutation(ThirdPartyForm_Emitters_Update_Mutation);
